import { useEffect, useState } from "react";
import { UserOccupationE } from "models/enums";
import { useUser } from "contexts/userContext/userContext";
import { getLocalStorage } from "utils/globalLocalStorage";
import { fetchIsPickerUser } from "../api";

interface UseShowPickerPromoReturn {
  showPickerPromo: boolean | null;
  isPickerUser: boolean;
}

const useShowPickerPromo = (): UseShowPickerPromoReturn => {
  const { isLoggedIn, getUserData } = useUser();
  const [showPromo, setShowPromo] = useState<boolean | null>(null);
  const [isPickerUser, setIsPickerUser] = useState<boolean>(false);

  useEffect(() => {
    if (getUserData()?.UserEncryptedId) {
      fetchIsPickerUser(getUserData()?.UserEncryptedId, setIsPickerUser);
    }
  }, [getUserData()?.UserEncryptedId]);

  // occupation promo logic
  useEffect(() => {
    // condition to show PickerPromoIcon

    // if user is subuser or topuser, we don't show promo
    if (getUserData().IsSubUser || getUserData().isTopUser) {
      setShowPromo(false);
      return;
    }

    // if user is picker we show promo always
    if (isPickerUser) {
      setShowPromo(true);
      return;
    }

    // if anonimus user(not logged in) and promo was closed less than 24 hours ago, we don't show promo
    const pickerPromoClosedTime = getLocalStorage("pickerPromoClosed");
    if (
      !isLoggedIn() &&
      pickerPromoClosedTime &&
      new Date().getTime() - parseInt(pickerPromoClosedTime) < 86400000
    ) {
      setShowPromo(false);
      return;
    }

    if (getLocalStorage("hidePickerPromo") === "true") {
      setShowPromo(false);
      return;
    }

    // if user is logged in and not photographer, we don't show promo
    if (
      isLoggedIn() &&
      getUserData().UserOccupation !== UserOccupationE.PHOTOGRAPHER &&
      getLocalStorage("pickerPromoShow") !== "true" // when pickerPromoShow is true, we show promo again
    ) {
      setShowPromo(false);
      return;
    }

    setShowPromo(true);
  }, [
    isPickerUser,
    getUserData(),
    getLocalStorage("hidePickerPromo"),
    getLocalStorage("pickerPromoShow"),
  ]);

  // return showPromo as default value and isPickerUser as a dependency
  return { showPickerPromo: showPromo, isPickerUser };
};

export default useShowPickerPromo;
